// extracted by mini-css-extract-plugin
module.exports = {"Skill":"SkillInput_Skill__3qlg9","SkillContainer":"SkillInput_SkillContainer__2T7FG","Cross":"SkillInput_Cross__3cmzD"};